var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.526.417H2.153C1.313.417.579 1.02.579 1.85V17.26c0 .834.734 1.578 1.574 1.578h15.368c.845 0 1.478-.749 1.478-1.578V1.85c.005-.83-.633-1.434-1.473-1.434ZM6.29 15.77H3.65V7.566H6.29v8.205ZM5.06 6.319h-.02c-.844 0-1.39-.63-1.39-1.416 0-.801.56-1.415 1.424-1.415.864 0 1.392.61 1.41 1.415 0 .787-.546 1.416-1.424 1.416Zm10.872 9.452h-2.639v-4.486c0-1.075-.384-1.81-1.338-1.81-.73 0-1.162.494-1.354.975-.072.172-.09.408-.09.648v4.673h-2.64V7.566h2.64v1.142c.383-.547.983-1.334 2.379-1.334 1.732 0 3.043 1.142 3.043 3.603v4.794Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.fda82681777e607313ece8e8dc875853.svg";
export { ForwardRef as ReactComponent };